import { translate } from "@atoms/atom-client/i18n";
import type { FunctionalRoleOption } from "@atoms/atom-types";
import {
  DESIGNER_ENGINEER_PERMISSION,
  INSTRUMENT_MANAGER_PERMISSION,
  ORDER_MANAGER_PERMISSION,
  PRICE_CALCULATOR_PERMISSION,
  SUNLAB_IMPORT_TEMPLATES_PERMISSION,
  USER_MANAGER_PERMISSION,
} from "./roleConstants";

/**
 * Functional role options for user administration UI.
 * Labels and descriptions are app-specific; role keys must match `provisionPermissionsByRoles`.
 */
export const functionalRoleOptions: FunctionalRoleOption[] = [
  {
    value: ORDER_MANAGER_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.orderManager.label",
        "Bestellungsadmin",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.orderManager.description",
        "Bestellungen importieren und Import-Protokolle einsehen",
      );
    },
  },
  {
    value: PRICE_CALCULATOR_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.priceCalculator.label",
        "Preisberechnung",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.priceCalculator.description",
        "Preisdaten und Kalkulationsdaten verwalten",
      );
    },
  },
  {
    value: DESIGNER_ENGINEER_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.designerEngineer.label",
        "Designer / Engineer",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.designerEngineer.description",
        "Positionen, Bestellungen, Vorlagen, Optionsbibliothek und Modelle bearbeiten",
      );
    },
  },
  {
    value: SUNLAB_IMPORT_TEMPLATES_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.sunlabImportTemplates.label",
        "Sunlab Import Vorlagen",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.sunlabImportTemplates.description",
        "Vorlagen verwalten und getaggte Sunlab-Vorlagen bearbeiten",
      );
    },
  },
  {
    value: INSTRUMENT_MANAGER_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.instrumentManager.label",
        "Instrumentendatenbank",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.instrumentManager.description",
        "Instrumente und ihre Maße für die Case-Auswahl verwalten",
      );
    },
  },
  {
    value: USER_MANAGER_PERMISSION,
    get label() {
      return translate(
        "app.shared.functionalRoles.userManager.label",
        "Nutzerverwalter",
      );
    },
    get description() {
      return translate(
        "app.shared.functionalRoles.userManager.description",
        "Benutzer einladen, bearbeiten und Passwort-Reset senden",
      );
    },
  },
];
